import { FCWithChildren } from '@types';
import React from 'react';
import { Loading, Modal, ModalBody } from '@components';

type ModalVerificationProps = {
  error?: any;
  loading?: boolean;
  isOpen: boolean;
  onClose?: () => void;
};

const ModalVerificationVerify: FCWithChildren<ModalVerificationProps> = ({
  error,
  loading,
  isOpen,
  onClose = () => {},
}) => {
  return (
    <Modal closeModal={onClose} isOpen={isOpen} closeOnEscape={false}>
      <ModalBody>
        {loading ? (
          <Loading />
        ) : error ? (
          <>
            <div className="mb-6">
              <h1 className="text-3xl antialiased font-normal">Verification Error</h1>
            </div>
            <p>
              Your code may have expired or there was a problem registering your device. Please try
              again.
            </p>
          </>
        ) : (
          <>
            <div className="mb-6">
              <h1 className="text-3xl antialiased font-normal">Registered!</h1>
            </div>
            <p>Your device now has full access to network resources.</p>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalVerificationVerify;
